import { queryOptions, useQuery } from "@tanstack/react-query";
import { selectProfilesByRoles } from "@/features/profile/api/selectProfilesByRoles";

export async function selectValidators() {
    return selectProfilesByRoles({ roles: ["VALIDATOR"] });
}

export const validatorsQueryOptions = () =>
    queryOptions({
        queryKey: ["users", "validators"],
        queryFn: () => selectValidators(),
    });

export function useValidatorsQuery() {
    return useQuery(validatorsQueryOptions());
}
